<template>
  <v-container fluid class="px-8 py-0">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      <div>
        <v-row>
          <v-switch v-model="listQuery.orderby_id_desc" label="倒序" style="max-width: 100px;" class="mx-3"></v-switch>
          <v-select v-model="listQuery.project_id" :items="projectsOptions" item-text="name" item-value="id"
            menu-props="auto" hide-details label="项目" single-line style="max-width: 100px;" class="mx-3 mb-3"
            @change="getQuery"></v-select>

          <v-select v-model="listQuery.village_id" :items="villagesOptions" item-text="name" item-value="id"
            menu-props="auto" hide-details label="所在村" single-line style="max-width: 100px;" class="mx-3 mb-3"
            @change="getQuery"></v-select>
          <v-text-field v-model="listQuery.customer_name" label="姓名" hide-details single-line class="mx-3 mb-3"
            style="max-width: 65px;" />
          <!-- <v-text-field
            v-model="listQuery.sub_name"
            label="受托人"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 80px;"
          /> -->
          <v-text-field v-model="listQuery.cardid" label="身份证号" hide-details single-line class="mx-3 mb-3"
            style="max-width: 150px;" />
          <v-text-field v-model="listQuery.phone" label="手机号" hide-details single-line class="mx-3 mb-3"
            style="max-width: 100px;" />
          <v-select v-model="listQuery.garden_name" :items="gardenOptions" item-text="garden_name"
            item-value="garden_name" menu-props="auto" hide-details label="小区" single-line style="max-width: 150px;"
            class="mx-3" @change="getQuery"></v-select>

          <v-select v-model="listQuery.building_name" :items="buildingOptions" item-text="building_name"
            item-value="building_name" menu-props="auto" hide-details label="幢" single-line style="max-width: 50px;"
            class="mx-3" @change="getQuery"></v-select>

          <v-select v-model="listQuery.unit_name" :items="unitOptions" item-text="unit_name" item-value="unit_name"
            menu-props="auto" hide-details label="单元" single-line style="max-width: 50px;" class="mx-3"
            @change="getQuery"></v-select>

          <v-text-field v-model="listQuery.house_number" class="mx-3" label="门牌号码" hide-details single-line
            style="max-width: 80px;" />

          <!-- <v-checkbox
            v-model="listQuery.orderby_id_desc"
            label="倒序"
            class="mx-3"
          >
          </v-checkbox> -->
          <v-select
            v-model="listQuery.status"
            :items="statusByOptions"
            item-text="display_name"
            item-value="key"
            menu-props="auto"
            hide-details
            label="状态"
            single-line
            style="max-width: 50px;"
            class="mx-2"
          ></v-select>
          <v-menu
            v-model="start_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="listQuery.start_date"
                label="最早交房日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="listQuery.start_date"
              @input="start_menu = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-model="end_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="listQuery.end_date"
                label="最迟交房日期"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="listQuery.end_date"
              @input="end_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-row>
      </div>
      <div>
        <v-row class="mt-2"><v-btn @click="getQuery" color="primary" class="mx-3">
            查询
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>

          <v-btn @click="resetQuery" color="primary" class="mx-3">
            重置
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>

          <export-excel :fields="exportFields" worksheet="签约数据" name="魏塘街道抽签签约数据.xls" :fetch="getListforExport">
            <v-btn color="primary" class="mx-3">
              导出
              <v-icon right>mdi-arrow-down-bold-circle-outline</v-icon>
            </v-btn>
          </export-excel>

          <div v-if="isAdminRole">
            <AddContractDialog />
          </div>
          <div v-if="isAdminRole">
            <AddScanContractDialogSingle />
          </div>
          <div v-if="isAdminRole">
            <AddScanContractDialogBatch />
          </div>
        </v-row>
      </div>
    </v-row>

    <!-- <v-divider class="mt-3" /> -->

    <v-simple-table fixed-header class="pa-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>户主编号</th>
            <th>项目名称</th>
            <th>姓名</th>
            <th>身份证号</th>
            <th>手机号</th>
            <th>安置面积</th>
            <th>所在村</th>
            <th>具体地址</th>
            <th>详细资料</th>
            <th>交房时间</th>
            <th>完成时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id">
            <td class="font-weight-light text-left" style="font-size:11px">
              {{ row.id }}
            </td>
            <td class="text-left">
              {{ row.customer_code1 }}
            </td>
            <td class="text-left">
              {{ row.project_real_name }}
            </td>
            <td class="text-left">
              {{ row.customer }}
            </td>
            <td class="text-left">
              {{ row.cardid }}
            </td>
            <td class="text-left">
              {{ row.phone }}
            </td>
            <td class="text-left">
              {{ row.myarea }}
            </td>
            <td class="text-left">
              {{ row.village }}
            </td>
            <td class="text-left">
              {{ row.address }}

            </td>

            <td>
              <v-simple-table dense class="background-transparent">
                <template v-slot:default>
        <tbody>
          <tr>
            <td class="text-left" width="100">{{ row.garden_name }}</td>
            <td class="text-right" width="90">{{ row.building_name }}幢</td>
            <td class="text-right" width="90" v-if="row.unit_name">{{ row.unit_name }}单元</td>
            <td class="text-right" width="90" v-else></td>
            <td class="text-right" width="90">{{ row.house_number }}室</td>
            <td class="text-right" width="100">{{ row.area }}㎡</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    </td>
    <td class="text-left" >
      {{
        row.delivery_time?$moment(row.delivery_time)
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"):""
      }}
    </td>
    <td class="text-left">
      {{
        row.success_time?$moment(row.success_time)
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"):""
      }}
    </td>
    </tr>
    </tbody>
    </template>
    </v-simple-table>
    <v-pagination v-model="listQuery.page" :circle="circle" :disabled="disabled" :length="total_pages"
      :next-icon="nextIcon" :prev-icon="prevIcon" :total-visible="totalVisible" :value="listQuery.page"
      @input="paginationChangeHandler" class="my-3"></v-pagination>
    <div style="text-align: right;
    width: 100%;
    margin-bottom: 20px;margin-top: -44px;max-width: 100%;color: gray;">共有{{ total_items }}条记录</div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
const statusByOptions = [
  { key: '1', display_name: "已办理" },
  { key: '2', display_name: "已完成" },
];


import {
  fetchContracts,
} from "@/api/contracts";
import {
  fetchGarden,
  fetchBuilding,
  fetchUnit
} from "@/api/customers";

import { fetchProjectsList } from "@/api/projects";
import { fetchVillagesList } from "@/api/villages";
export default {
  name: "Contracts",

  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    panel: [0, 1],
    printer: {
      single: {
        color: "blue",
        icon: "mdi-printer"
      },
      batch: {
        color: "secondary",
        icon: "mdi-printer"
      },
      pay: {
        color: "green",
        icon: "mdi-cash-usd"
      }
    },
    exportItems: [],
    items: [],
    listQuery: {
      page: 1,
      limit: 12,
      customer_code: undefined,
      customer_name: undefined,
      sort: "+id",
      orderby: undefined,
      village_id: undefined,
      start_date: undefined,
      end_date: undefined,
      status:undefined
    },
    villagesOptions: [],
    projectsOptions: [],
    gardenOptions: [],
    buildingOptions: [],
    unitOptions: [],
    statusByOptions,
    search: "",
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    // activityOptions,
    // pageOptions,
    exportFields: {
      序号: "id",
      项目名称: "project_name",
      实际项目名称: "project_real_name",
      顺序号: "customer_lottery_sequence",
      户主名称: "customer",
      户主编号: {
        field: "code",
        callback: value => {
          return `'${value}`;
        }
      },
      身份证号: {
        field: "cardid",
        callback: value => {
          return `'${value}`;
        }
      },
      手机号码: "phone",
      行政村: "village",
      具体地址: "address",
      腾空时间:"empty_time",
      小区: "garden_name",
      楼幢: {
        field: "building_name",
        callback: value => {
          return `'${value}`;
        }
      },
      单元: "unit_name",
      房号: "house_number",
      面积: "area",
      楼层: "floor",
      楼高: "floors",
      层级差: "feefloat",
      标准价:"population_price_discount",
      标准面积:"population_area",
      标准金额:"population_fee",
      产权置换价:"property_price_discount",
      产权置换面积:"property_area",
      产权置换金额:"property_fee",
      特殊价格:"special_price_discount",
      特殊面积:"special_area",
      特殊金额:"special_fee",
      不可分割价:"extend_price_discount",
      不可分割面积:"extend_area",
      不可分割金额:"extend_fee",
      市场优惠价:"market_discount_price_discount",
      市场优惠面积:"market_discount_area",
      市场优惠金额:"market_discount_fee",
      车库编号: "sub_name",
      车库面积: "sub_area",
      车库金额: "sub_fee",
      房款金额: "house_fee",
      房款车库金额: "total_house_fee",
      物业专项维修基金: "repair_special_fee",
      车库维修基金: "sub_repair_fee",
      代收费: "proxy_fees",
      总金额: "total_fee",
      产权人: {
        field: "agreement",
        callback: value => {
          if (typeof(value[0]) != "undefined"){
            const agreement = value[0];
            if (agreement) {
              return agreement.customer;
            }
          }
          
        }
      },
      交房时间: {
        field: "delivery_time_export",
        callback: value => {
          return `'${value}`;
        }
      },
      是否交款: {
        field: "is_pay",
        callback: value => {
          if (value==1){
            return '已交款'
          }else{
            return '未交款'
          }
        }
      },
      完成时间: "success_time_export",
      导入时间: "create_at_export",
    },



    greenColor: "rgb(81, 185, 116)",
    warningColor: "rgb(241, 211, 171)",
  }),

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
    this.getVillagesList();
    this.getProjectsList();
    this.getGardens();
    this.getBuildings();
    this.getUnits();
    console.log(Date.now());
  },
  methods: {
    getQuery() {
      this.listQuery.page = 1;
      this.getList()
    },
    getList() {
      this.listLoading = true;
      this.listQuery.limit = 10;
      // this.listQuery.keyword = this.search
      console.log(this);
      fetchContracts(this.listQuery).then(response => {
        this.items = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        this.total_items = response.data._meta.total_items;
        console.log(this.items);

        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

    getListforExport() {
      this.listLoading = true;
      this.listQuery.page = 1;
      this.listQuery.limit = 4000;
      fetchContracts(this.listQuery).then(response => {
        this.exportItems = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      return this.exportItems;
    },

    getProjectsList() {
      this.listLoading = true;
      console.log("getProjectsList");
      fetchProjectsList().then(response => {
        this.projectsOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },

    getVillagesList() {
      this.listLoading = true;
      console.log("getVillagesList");
      fetchVillagesList().then(response => {
        this.villagesOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },

    resetQuery() {
      this.listQuery.page = 1;
      this.listQuery.orderby = undefined;
      this.listQuery.id = undefined;
      this.listQuery.cardid = undefined;
      this.listQuery.customer_name = undefined;
      this.listQuery.project_id = undefined;
      this.listQuery.village_id = undefined;
      this.listQuery.garden_name = undefined;
      this.listQuery.building_name = undefined;
      this.listQuery.unit_name = undefined;
      this.listQuery.house_number = undefined;
      this.listQuery.phone = undefined;
      this.getList();
      console.log("resetQuery");
    },
    getGardens() {
      fetchGarden().then(response => {
        this.gardenOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("gardenOptions:", this.gardenOptions);
    },
    getBuildings() {
      fetchBuilding().then(response => {
        this.buildingOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("buildingOptions:", this.buildingOptions);
    },
    getUnits() {
      fetchUnit().then(response => {
        this.unitOptions = response.data[0];
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      console.log("unitOptions:", this.unitOptions);
    },
    paginationChangeHandler(pageNumber) {
      this.listQuery.page = pageNumber;
      this.getList();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped>
table,
thead,
tr {
  color: #fff;
  font-weight: 400;
}

.background-transparent {
  background-color: transparent !important;
}

tr:hover {
  background-color: #0282b4 !important;
}
</style>
